/**
 * Defines the routes that the App Menu flyout uses to direct the user to
 * various locations within the app.
 */
export const VENUE_SETTINGS_NAV_TARGET = '/settings/company/settings'
export const CONNECTIONS_NAV_TARGET = '/settings/company/connections'
export const VENUE_ONBOARDING_NAV_TARGET = '/venue-onboarding'
export const PROFILE_NAV_TARGET = '/settings/profile'
export const BILLING_NAV_TARGET = '/settings/billing'
export const BILLING_VENUES_NAV_TARGET = '/settings/billing/venues'
export const NEW_VENUE_NAV_TARGET = '/settings/venues/new'
export const MANAGE_USERS_NAV_TARGET = '/settings/users'
